import React, { FC } from "react"
import styled, { css } from "styled-components"
import { theme } from "../../../util/styles/theme"
import { BoxSize } from "../../box/Box"
import { CollapsibleContext } from "../../collapsible/components/CollapsibleContext"
import { CardActions } from "./CardActions"

export interface CardContentProps {
  className?: string
  size?: BoxSize
}

type ContainerProps = {
  show?: boolean
} & Pick<CardContentProps, "size">

const Container = styled.div<ContainerProps>`
  padding: 0 ${({ size }) => size && theme.borderRadius[size]}
    ${({ size }) => size && theme.borderRadius[size]};

  &:first-child {
    padding-top: ${({ size }) => size && theme.borderRadius[size]};
  }

  ${({ show }) =>
    !show &&
    css`
      display: none;
    `};

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  & ${CardActions} {
    margin-top: ${({ size }) => size && theme.borderRadius[size]};
  }
`
export const CardContent: FC<CardContentProps> = ({
  className,
  size,
  children,
}) => {
  const context = React.useContext(CollapsibleContext)

  return (
    <Container className={className} show={!context.isCollapsed} size={size}>
      {children}
    </Container>
  )
}

CardContent.defaultProps = {
  size: "medium",
}
